import {
  searchAppPath,
} from '../../../util/paths';

export const searchFilterPath = `${searchAppPath}`;
export const newSearchFilterPath = `${searchAppPath}/new`;
export const editSearchFilterPath = `${searchAppPath}/:searchFilterId/edit`;
export const getEditSearchFilterPath = searchId => `${searchAppPath}/${searchId}/edit`;
